<script setup lang="ts">
import { ref, toRefs } from "vue";
import { z } from "zod";

import QuestionnaireResponsesChart from "@/components/QuestionnaireResponsesChart.vue";
import type { FilterCriteria } from "@/components/QuestionnaireResponsesFilter.vue";
import QuestionnaireResponsesFilter from "@/components/QuestionnaireResponsesFilter.vue";
import { useValidatedProps } from "@/composable";
import { questionnaireWithResponsesSchema } from "@/types";

const { questionnairesWithResponses } = toRefs(
  useValidatedProps(
    z.object({
      questionnairesWithResponses: z.array(questionnaireWithResponsesSchema),
    }),
  ),
);

const filterCriteria = ref<FilterCriteria>({
  questionnaireIds: questionnairesWithResponses.value
    .filter((questionnaire) => questionnaire.responses.length > 0)
    .map((questionnaire) => questionnaire.id),
});
</script>

<template>
  <div class="d-flex flex-column flex-md-row p-3 gap-3">
    <aside class="p-1" style="max-width: 300px">
      <QuestionnaireResponsesFilter
        v-model="filterCriteria"
        :questionnaires="questionnairesWithResponses"
      />
    </aside>
    <main class="flex-grow-1 min-w-0">
      <QuestionnaireResponsesChart
        :filter="filterCriteria"
        :questionnaires="questionnairesWithResponses"
      />
    </main>
  </div>
</template>
